export const ARCHIVE = ``;
export const INSIGHTS = `insights`;
export const ANALYTICS = `analytics`;
export const TENSILE = `tensile`;
export const CERTIFICATION = `certification`;
export const ADMIN = `admin`;
export const TESTS = `tests`;
export const PIP_TEST = 'test/:pipTestUUID';
export const LOGIN = 'login';
export const ERROR_404 = 'error/404';
export const ERROR_401 = 'error/401';

export const PORTABLE_ARCHIVE = `portable/`;
export const PORTABLE_INSIGHTS = `portable/insights`;
export const PORTABLE_CERTIFICATION = `portable/certification`;

const urls = {
    LOGIN,
    ARCHIVE,
    ANALYTICS,
    TENSILE,
    CERTIFICATION,
    INSIGHTS,
    TESTS,
    PIP_TEST,

    PORTABLE_ARCHIVE,
    PORTABLE_INSIGHTS,
    PORTABLE_CERTIFICATION,

    ERROR_404,
    ADMIN,
};

export default urls;
